// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--sim7I","card":"card--AkfsW","backgroundImg":"backgroundImg--MguaQ","content":"content--QueYL","markerAnimationScale":"markerAnimationScale--reNgZ"};